// @flow weak

// !!! IMPORTANT !!!
//
// This file is shared between the zapier/zapier and zapier/next-js repository.
// Any changes made here should be reflected in there as well.
// For more information, see: https://zapier.quip.com/xaKqAOpdhpY2#ZXFACA8Jnp9
import React from 'react';
import bemify from 'bemify-js';
import { pure } from 'recompose';

import type { HOC } from 'recompose';

type LoadingStarProps = { className?: string };

const LoadingStar = props => {
  const classes = bemify('', 'spinner', props.type);
  return <div className={classes} />;
};

const enhanceLoadingStar: HOC<*, LoadingStarProps> = pure;

export default enhanceLoadingStar(LoadingStar);
